module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/S14IBu/tc-custom/9780740790584.jpg?1729082544956",
      "alt": "This image is the cover for the book Silent But Deadly"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Silent But Deadly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This strip offers a fresh outlook and appeals to everyone . . . LIO is a comic strip that's edgy, funny, visually stunning, and truly different.\" --"), _c('i', [_vm._v("Daily Cartoonist")])]), _c('p', [_vm._v("With a feature film in the works from producer David Kirschner ("), _c('i', [_vm._v("Child's Play, An American Tail")]), _vm._v("), LIO deftly melds the macabre with its brand of dark humor.")]), _c('p', [_vm._v("Having been distinguished by "), _c('i', [_vm._v("Variety")]), _vm._v(" as \"a fast riser,\" Mark Tatulli's morbidly mirthful pantomime comic strip, LIO, is humorously astute and just slightly askew in its perception of the world.")]), _c('p', [_vm._v("Centered around an odd, ghostly-pale child named LIO, and his creepy coterie of friends, including a giant squid named Ishmael and a scythe-carrying grim reaper, LIO; is influenced by cartooning greats Gahan Wilson, Charles Addams, and 19th-century satirist A. J. Volck. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Mark Tatulli\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0